// src/store/dashboard/index.js
import brand from './brand'
import mt from './mt'
import operational from './operational'
import shared from './shared'
import opMtBrand from './op-mt-brand'

export default {
  namespaced: true,
  modules: {
    brand,
    mt,
    operational,
    shared,
    'op-mt-brand': opMtBrand
  }
}
